import { useCallback } from 'react';
import { getUserService } from '../service/ServiceRegistry';
import type {
  TvUserOnboardingRequest,
  TvUserOnboardingResponse,
} from '../types/api/tv-user';

/**
 * Hook for TV user onboarding
 *
 * Provides onboardTvUser to create TV platform users via admin
 */
export function useTvUserOnboarding() {
  const userService = getUserService();

  const onboardTvUser = useCallback(
    async (request: TvUserOnboardingRequest): Promise<TvUserOnboardingResponse> => {
      try {
        return await userService.onboardTvUser(request);
      } catch (error) {
        console.error('Failed to onboard TV user:', error);
        throw error;
      }
    },
    [userService]
  );

  return { onboardTvUser };
}
